<template>
  <span v-if="headers[section]" v-html="headers[section]" class="brief-explanation" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    section: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      headers: 'sectionLabels/headers',
    }),
  },
}
</script>
